module.exports = __webpack_public_path__ + "img/map.644a306.png";